import { useEffect, useState } from 'react';

export const useHeldTrue = (value: boolean, holdMs: number): boolean => {
  const [held, setHeld] = useState(value);
  if (value && !held) {
    setHeld(true);
  }

  useEffect(() => {
    if (value || !held) {
      return;
    }
    const timeout = setTimeout(() => setHeld(false), holdMs);
    return () => clearTimeout(timeout);
  }, [value, held, holdMs]);

  return value || held;
};
